export default __webpack_public_path__ + "static/media/GraftCafe-7.2ee1f911.jpg";